import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Plataforma } from '../models/plataforma.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlataformaService {
  configHeader: any;

  constructor(
    private http: HttpClient
    ) { }
    
  public listar(token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/plataformas`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error.message);
          }
        )
    })
  }

  public getPlataforma(idPlataforma: number,  token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.get(`${environment.url_api}/plataformas/${idPlataforma}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }

  public salvarPlataforma(plataforma: Plataforma, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.post(`${environment.url_api}/plataformas`, plataforma, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }
  public editarPlataforma(idPlataforma: number, plataforma: Plataforma, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.put(`${environment.url_api}/plataformas/${idPlataforma}`, plataforma, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }

  public excluirPlataforma(idPlataforma: number, token: any) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
        this.http.delete(`${environment.url_api}/plataformas/${idPlataforma}`, this.configHeader).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err);
          }
        )
    })
  }
  
}
